/** Naming and routing for extraction jobs, shared by the log and the dock. */
import type { useIntl } from 'react-intl';

import type { ExtractionJobResponse, ExtractionKind } from '@/client/types.gen';
import { route } from '@/routes/paths';

export const KIND_FOR_CLASSIFICATION: Record<ExtractionKind, string> = {
  finance: 'expense',
  booking: 'booking',
  explore: 'listing',
  documentation: 'document',
  other: 'document',
  ignore: 'junk',
};

export function classificationLabel(
  intl: ReturnType<typeof useIntl>,
  classification: ExtractionKind,
): string {
  switch (classification) {
    case 'finance':
      return intl.formatMessage({
        id: '0c9a4e71-5b38-4d26-8f10-3a7e6b2d5c94',
        defaultMessage: 'Expense',
      });
    case 'booking':
      return intl.formatMessage({
        id: '7e1b6c05-9d42-4a83-b527-0f8c3a6d1e79',
        defaultMessage: 'Stay',
      });
    case 'explore':
      return intl.formatMessage({
        id: '3d5f8a20-6c91-4b47-9e08-2b6a5d0c7f13',
        defaultMessage: 'Home',
      });
    case 'ignore':
      return intl.formatMessage({
        id: '6f2b9d47-8a03-4c15-be76-1d9e4a2c8b50',
        defaultMessage: 'Ignored',
      });
    default:
      return intl.formatMessage({
        id: '9a2c7e64-0d15-4f83-b96e-5c1a8b3d7042',
        defaultMessage: 'Document',
      });
  }
}

export function jobTargetRoute(homeId: string, job: ExtractionJobResponse): string {
  if (job.target_type === 'expense')
    return route('homeExpense', { homeId, expenseId: job.target_id! });
  if (job.target_type === 'booking')
    return `${route('homeSchedule', { homeId })}?reservation=${job.target_id}`;
  return route('homeDocument', { homeId, documentId: job.target_id! });
}

export function jobLabel(
  intl: ReturnType<typeof useIntl>,
  job: ExtractionJobResponse,
): string {
  return (
    job.filename ||
    job.subject ||
    job.sender ||
    intl.formatMessage({
      id: '6ea1cd5f-d93c-4c17-a41e-bba322036ff4',
      defaultMessage: 'Inbox email',
    })
  );
}
